/** MODULE_MAPS places Rooms under Calendar; callers apply this only to next navigation. */
export function placeRoomBookingsUnderCalendar<T extends { href?: string; matchPrefixes?: string[] }>(items: T[]): T[] {
  return items.map((item) => {
    if (item.href === "/dashboard" && item.matchPrefixes?.includes("/room-bookings")) {
      return { ...item, matchPrefixes: item.matchPrefixes.filter((prefix) => prefix !== "/room-bookings") };
    }
    if (item.href === "/events" && item.matchPrefixes && !item.matchPrefixes.includes("/room-bookings")) {
      return { ...item, matchPrefixes: [...item.matchPrefixes, "/room-bookings"] };
    }
    return item;
  });
}
